export class endpoints {
    public getLanguages = '/core/languages';
    public getCurrencies = '/core/currencies';
    public getFeaturedFlight = '/core/featured-flight';
    public getSocialMedia = '/core/social-media';
    public getApiLogin = '/api-login';
    public getTokenValidity = '/check-token-validity';
    public getRefreshToken = '/refresh-token';
    public getDownloadApp = '/core/app-download-preference';
    public getHomeBanner = '/core/get-home-banner';
    public getLanguageTranslate = '/core/language-translate'; //fetch dynamic translated language on base of language code
    public searchAirport = '/flight/search/airport';
    public searchFlight = '/flight/flight-offers-search';
    public getCancellationData = '/flight/flight-offers-price';
    public getAmenitiesData = '/flight/flight-offers-seatmap-amenities';
    public getGeneral = '/core/getGeneral';
    public getFlightData = '/flight/flight-offers-price';
    public bookFlight = '/flight/flight-order-create';
    public getHotelAutoSearch = '/hotel/hotel-auto-search';
    public getHotelAvailability = '/hotel/hotel-availability';
    public getHotelDetails = '/hotel/hotel-details';
    public getCountryList = '/geography/get-countries';
    public getStateList = '/geography/get-states';
    public getCityList = '/geography/get-city';
    public customerLogin = '/customer/customer-login';
    public customerSignUp = '/customer/customer-signup';
    public sendVerificationOTP = '/customer/verification-otp/send';
    public verifyOTP = '/customer/verification-otp/verify';
    public getPageCodes = '/page/page-code';
    public getPages = '/page/get-pages';
    public getBookings = "/customer/bookings";
    public getBookingDetail = "/customer/booking-detail";
    public customerLogout = "/customer/logout-customer";
    public sendForgotPwdOTP = '/customer/forgot-password-otp/send';
    public verifyForgotPwdOTP = '/customer/forgot-password-otp/verify';
    public resetPassword = '/customer/reset-password';
    public getCustomerProfile = '/customer/get-customer-profile';
    public updateCustomer = '/customer/update-customer';
    public closeCustomerAccount = '/customer/close-account';
    public getGeoLocationByIP = '/geo-location-by-ip';
    public getArabiCountries = '/core/get-arabic-speak-countries';
    public changePassword = '/customer/change-password';
    public getTravellerList = '/customer/get-traveller-list';
    public getTraveller = '/customer/get-traveller';
    public createTraveller = '/customer/create-traveller';
    public updateTraveller = '/customer/update-traveller';
    public deleteTraveller = '/customer/delete-traveller';
}
